import { useEffect, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import { useStore } from "@nanostores/react"
import BlinkingRobot from "@/components/animations/BlinkingRobot"
import CloseIcon from "@/assets/icons/constant-floater-close.svg"
import CircleArrowRight from "@/assets/icons/circle-arrow-right.svg"
import { $myLeadsDismissed, setMyLeadsDismissed } from "@/stores/userPrefs"
import { myLeadsBannerViewed } from "@/analytics/events/properties"
import BFText from "@/components/standard/BFText"

interface FullBannerProps {
  onSelect: () => void
  onDismiss: () => void
}

const FullBanner = ({ onSelect, onDismiss }: FullBannerProps) => {
  useEffect(() => {
    myLeadsBannerViewed({
      text: "Never miss the perfect deal with My Leads. SYNC NOW! / Set up My Leads",
      size: "medium",
      position: "bottom",
    })
  }, [])

  return (
    <TouchableOpacity
      testID={"setup-my-leads-banner"}
      className="absolute inset-x-4 bottom-0 p-3 bg-teal rounded-[6px] border"
      onPress={onSelect}
    >
      <View className="flex flex-1 flex-row">
        <View className="items-center justify-center">
          <BlinkingRobot />
        </View>
        <View className="flex flex-1 flex-col ml-3">
          <View className="flex-row flex-1">
            <BFText className="font-figtree-bold">
              Never miss the perfect deal with My Leads.{" "}
              <BFText className="underline">SYNC NOW!</BFText>
            </BFText>
          </View>
        </View>
        <TouchableOpacity
          testID={"close-button"}
          className="flex items-center justify-center mr-1"
          onPress={onDismiss}
        >
          <CloseIcon width={10} height={10} />
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  )
}

interface MiniBannerProps {
  onSelect: () => void
}

const MiniBanner = ({ onSelect }: MiniBannerProps) => {
  useEffect(() => {
    myLeadsBannerViewed({
      text: "Set up My Leads",
      size: "small",
      position: "bottom-right",
    })
  }, [])
  return (
    <TouchableOpacity
      testID={"my-leads-mini-banner"}
      className="absolute bottom-0 right-4 w-[130px] p-2 bg-teal rounded-[6px] border"
      onPress={onSelect}
    >
      <View className="flex flex-1 flex-row items-center justify-center">
        <View className="flex flex-1">
          <BFText className="text-midnight-blue font-figtree-bold text-[12px]">
            Set up My Leads
          </BFText>
        </View>
        <View className="flex w-[15px]">
          <CircleArrowRight width={15} height={14} />
        </View>
      </View>
    </TouchableOpacity>
  )
}

export interface MyLeadsConnectBannerProps {
  onSelect: () => void
}

export default function MyLeadsConnectBanner({
  onSelect,
}: MyLeadsConnectBannerProps) {
  const myLeadsDismissed = useStore($myLeadsDismissed)
  const [bannerClosed, setBannerClosed] = useState<boolean>(false)

  const closeMyLeadsBanner = () => {
    setBannerClosed(true)
    setMyLeadsDismissed()
  }

  if (bannerClosed) {
    return null
  }

  if (myLeadsDismissed) {
    return <MiniBanner onSelect={onSelect} />
  }
  return <FullBanner onSelect={onSelect} onDismiss={closeMyLeadsBanner} />
}
